export default {
      id: "icon-gluten-usage",
      viewBox: "0 0 36 84.032",
      url: __webpack_public_path__ + "icons.svg#icon-gluten",
      toString: function () {
        return this.url;
      }
    }